import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import HttpClient from '../../utils/HttpClient';
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
import toast from 'react-hot-toast';
import NonMemberModal from '../../Component/Modal/NonMemberModal';
import moment from 'moment';
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import { saveAs } from 'file-saver';
import BusinessLIstingModal from '../../Component/Modal/BusinessLIstingModal';
import PostDetailsModal from '../../Component/Modal/PostDetailsModal';
import PostLikesModal from '../../Component/Modal/PostLikesModal';
import { formatLikeCounter } from '../../utils/helper';

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const dateTimeFormat = "DD-MM-YYYY, h:mmA"

const Comments = ({ data,backToPosts }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState("");
    const [AllData, setAllData] = useState([]);
    const [ExcelSheetData, setExcelSheetData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [filterCountryState, setfilterCountryState] = useState(false);
    const navigate = useNavigate()

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "5%",
        },
        // {
        //     name: 'View',

        //     cell: (row) => (
        //         <i className="fa-solid fa-eye " onClick={() => handleView(row?.allInfo)}
        //             style={{ cursor: "pointer", color: 'darkBlue', fontSize: '15px' }}></i>
        //     ),
        //     width: "5%",
        // },
        // {
        //     name: 'Like(s)',
        //     cell: (row) => (
        //         <>

        //             {row?.PostLikeCount ? (<>{formatLikeCounter(row.PostLikeCount)}&nbsp;<i className="fa-solid fa-eye " onClick={() => handlePostLikesView(row)}
        //                 style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i></>) : formatLikeCounter(0)}
        //         </>
        //     ),

        //     width: "9%",
        //     wrap: true,
        //     align: "center",
        // },
        // {
        //     name: 'Comment',

        //     cell: (row) => (
        //         <i className="fa-solid fa-eye " onClick={() => handleView(row?.allInfo)}
        //             style={{ cursor: "pointer", color: 'darkBlue', fontSize: '15px' }}></i>
        //     ),
        //     width: "5%",
        // },
        {
            name: 'Date',
            selector: row => moment(row.commentDate).format(dateTimeFormat),
            width: "10%",
            wrap: true
        },
        // {
        //     name: 'Subject',
        //     selector: row => row.subject,
        //     width: "15%",
        //     wrap: true
        // },
        // {
        //     name: 'Target Audience',
        //     selector: row => row.targetAudience,
        //     width: "10%",
        //     wrap: true
        // },
        {
            name: 'Comment',
            selector: row => row.comment,
            width: "55%",
            wrap: true
        },
        {
            name: 'Company Name',
            selector: row => row.companyName,
            width: "15%",
            wrap: true
        },

        {
            name: 'Person Name',
            selector: row => row.personName,
            width: "15%",
            wrap: true
        },
        // {
        //     name: 'Member',
        //     selector: row => row.memberStatus,
        //     width: "10%",
        //     wrap: true
        // },
        // {
        //     name: 'Status',
        //     selector: row => row.status,
        //     width: "10%",
        //     wrap: true
        // },
    ];
    const [selectedPostLikeDetails, setSelectedPostLikeDetails] = useState();
    const [isPostLikeModalOpen, setIsPostLikeModalOpen] = useState(false);
    //LIKE MODAL VIEW
    const handlePostLikesView = async (data) => {

        setSelectedPostLikeDetails(data?.PostLikeData);
        setIsPostLikeModalOpen(true);
    }

    const getAllData = async () => {
        setIsLoading(true);
        // const res = await HttpClient.requestData("business-posts", "GET", {});
        let apiData = []
        if (data) {
            setIsLoading(false);
            apiData = data?.map((item, i) => ({
                sl: i + 1,
                commentDate: item?.createdOn,
                comment: item?.comment,
                companyName: item?.commentedBy[0]?.companyName,
                personName: item?.commentedBy[0]?.personName,
                // subject: item?.subject || "N/A",
                // targetAudience: item?.targetAudience.join(", ") || "N/A",
                // searchKeywords: item?.searchKeywords.join(", ") || "N/A",
                // companyName: item?.userData?.companyName || "N/A",
                // personName: item?.userData?.personName || "N/A",
                // memberStatus: item?.userData?.memberStatus ? "Member" : "Non-member",
                // approveStatus: item?.approveStatus,
                // PostLikeCount: item?.PostLikeCount || 0,
                // PostLikeData: item?.PostLikeData.sort(
                //     (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                // ),
                // status: <div className='my-2'>
                //     {
                //         item?.approveStatus ? <button
                //             onClick={() => handleApproveStatus(item?._id, false)}
                //             type="button" className="btn btn-success"
                //             data-toggle="tooltip" data-placement="top">
                //             Approved<span style={{ fontSize: "12px", color: "#ffffff", display: "block" }}>Click to Disapprove</span>
                //         </button> : <button
                //             onClick={() => handleApproveStatus(item?._id, true)}
                //             type="button" className="btn btn-danger"
                //             data-toggle="tooltip" data-placement="top" title="Click to Approve"
                //         >Pending<span style={{ fontSize: "12px", color: "#ffffff", display: "block" }}>Click to Approve</span></button>
                //     }
                // </div>,
                // action: <EditDeleteIcon

                //     onClickEdit={(e) => handleEdit(item)}

                // />,
                // action: <EditDeleteIcon

                //     onClickEdit={(e) => handleEdit(item)}
                //     onClickDelete={(e) => handleDelete(item?._id)}
                // />
            }));

        } else {
            setIsLoading(false);
        }
        // Filter data based on search input        
        const filteredData = apiData?.filter(item =>
            item?.comment?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.companyName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.personName?.toLowerCase()?.includes(searchInput?.toLowerCase())
        ).sort(
            (a, b) => new Date(b.commentDate) - new Date(a.commentDate)
        );
        setAllData(filteredData);
        setExcelSheetData(filteredData.map(item => {
            const { status, approveStatus, action, ...rest } = item;
            return rest;
        }));
        // const filteredD = filteredData.filter(item => item.hasOwnProperty('status') && item.hasOwnProperty('action'));
        // console.log(filteredD,"fkjh")
    }

    //Activate
    const handleApproveStatus = async (id, value) => {
        setIsLoading(true);
        const data = {
            approveStatus: value
        }


        const res = await HttpClient.requestData(`approve-business-post/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status updated successfully!");
            getAllData();
        } else {
            setIsLoading(false);
        }
    }
    //MODAL VIEW
    const handleView = async (data) => {

        setSelectedDetails(data);
        setIsModalOpen(true);
    }
    //BUSINESS MODAL VIEW
    const handleBusinessView = async (id) => {

        setSelectedDetails(id);
        setIsBusinessModalOpen(true);
    }
    //edit
    const handleEdit = (item) => {
        navigate("/non-member-edit", { state: item })
    }
    // Function to export data to Excel
    const exportToExcel = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const fileName = 'users_data';

        const ws = XLSX.utils.json_to_sheet(ExcelSheetData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
    };
    useEffect(() => {
        getAllData();
    }, [searchInput])
    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        Comment(s)
                    </div>
                    <div className=" d-flex justify-content-between  mb-2" >
                        {/* filter by country and state */}
                        {!filterCountryState &&
                            <div className="d-flex flex-column  justify-content-between  mt-3" >
                                {/* <div className='mb-2'>
                                    <label htmlFor="formGroupExampleInput">Country<span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="formGroupExampleInput">Emirate <span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div> */}
                            </div>}
                        <div className="Search_box">
                            <form className="form-inline">
                                <input
                                    className="form-control h-75"
                                    type="search"
                                    placeholder="Search"
                                    aria-label="Search"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                                <div className="Search_icon">
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </div>
                            </form>
                            <div className="d-flex justify-content-end">
                                {/* Your existing JSX code */}
                                {/* <button className="btn btn-primary" onClick={exportToExcel}>Export to Excel</button> */}
                                {/* Your existing JSX code */}
                                <button className="btn btn-primary" onClick={backToPosts}>Back to All Posts</button>
                            </div>
                        </div>
                    </div>


                    <form>

                        <div>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded "
                                customStyles={customStyles}
                            />
                        </div>
                    </form>
                </section>
                <PostDetailsModal
                    isOpen={isModalOpen}
                    closeModal={() => setIsModalOpen(false)}
                    details={selectedDetails}
                />
                <PostLikesModal
                    isOpen={isPostLikeModalOpen}
                    closeModal={() => setIsPostLikeModalOpen(false)}
                    details={selectedPostLikeDetails}
                />
            </div>

        </div>
    )
}

export default Comments